import { useApp } from './AppProvider.tsx';
import type { SubEvent } from '../types/events.ts';
import { useMemo } from 'react';

const useRacesWithResults = (): SubEvent[] => {
  const [{ event }] = useApp();
  const { subEvents } = event ?? {};
  return useMemo(
    () =>
      (subEvents || []).filter(({ listingSettings }) => Boolean(listingSettings?.hasStatistics)),
    [subEvents]
  );
};

export default useRacesWithResults;
